import { Component, OnInit } from '@angular/core';

let footerLinks = {
  ONLINE_SECURITY: 'https://www.hsbc.com/online-security',
  HSBC_GROUP: 'https://www.hsbc.com/',
  CUSTOMER_SUPPORT: 'https://www.hsbcnet.com/gbm/customer-support',
  TERMS_AND_CONDITIONS: 'https://www1.secure.hsbcnet.com/uims/portal/TermsConditions',
  PRIVACY_AND_DATA: 'https://www1.secure.hsbcnet.com/uims/portal/DataProtection',
  HSBCNET_CONDITIONS: 'https://www1.secure.hsbcnet.com/uims/portal/NLSConditions'
};

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  footerLinks = footerLinks;

  constructor() { }

  ngOnInit() {
  }

  footerLinksNavigate(footerItem) {
    window.open(this.footerLinks[footerItem], '_blank');
  }
  
}
